'use strict';

const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('od-modules/utils/tracking.utils');

const MY_AREA_CATEGORY = 'my_area_account';

const toggleDialog = (open) => function() {
    this.$el.toggleClass('open opened', open);
};

const openDialog = toggleDialog(true);
const closeDialog = toggleDialog(false);

module.exports = withRenderedMain(BaseView.extend({
    initialize(options) {
        BaseView.prototype.initialize.call(this, options);
    },
    events: {
        'tap .cancel_account_close': 'onClose',
        'tap .account_pref_cancel_account_btn': 'onTapCancelAccount',
        'tap .account_pref_return': 'onTapReturnButton',
    },

    onClose() {
        trackingUtils.trackEventWithCategory(MY_AREA_CATEGORY, 'account_details', 'cancel_account_close_acc:no-prime');
        closeDialog.call(this);
    },

    onTapCancelAccount(event) {
        event.stopPropagation();
        event.preventDefault();
        trackingUtils.trackEventWithCategory(MY_AREA_CATEGORY, 'account_details', 'cancel_account_yes_acc:no-prime');
        Odigeo.Session.set('dontDisplayGoogleOneTap', true);
        Odigeo.trigger(this.id + ':submitUserRequest', {action: 'cancelAccount', data: ''});
    },

    onTapReturnButton(event) {
        event.stopPropagation();
        event.preventDefault();
        trackingUtils.trackEventWithCategory(MY_AREA_CATEGORY, 'account_details', 'cancel_account_no_acc:no-prime');
        closeDialog.call(this);
    },

    open() {
        trackingUtils.trackEventWithCategory(MY_AREA_CATEGORY, 'account_details', 'cancel_account_open_acc:no-prime');
        openDialog.call(this);
    },
}));
